
import { login, logout, getInfo } from '@/api/user';
import { getUserToken, setUserToken, removeUserToken } from '@/utils/auth';

const user = {
  state: {
    userToken: getUserToken(),
    name: '',
    avatar: '',
    user_id:0,
    waybill_api_permission:false,
    cbec_permission:false,
    order_sn_permission:false,
  },

  mutations: {
    SET_USER_TOKEN: (state, token) => {
      state.userToken = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_USER_ID: (state, user_id) => {
      state.user_id = user_id;
    },
    SET_WAYBILL_API_PERMISSION: (state, waybill_api_permission) => {
      state.waybill_api_permission = waybill_api_permission;
    },
    SET_CBEC_PERMISSION: (state, cbec_permission) => {
      state.cbec_permission = cbec_permission;
    },
    SET_ORDER_SN_PERMISSION: (state, order_sn_permission) => {
      state.order_sn_permission = order_sn_permission;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo){
      const username = userInfo.user_name.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.user_pass).then(response => {
          const data = response.data;
          setUserToken(data.user_token);
          commit('SET_USER_TOKEN', data.user_token);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }){
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data;
          commit('SET_NAME', data.user_nickname);
          commit('SET_AVATAR', data.avatar);
          commit('SET_USER_ID', data.user_id);
          commit('SET_WAYBILL_API_PERMISSION', data.waybill_api_permission==='on');
          commit('SET_CBEC_PERMISSION', data.cbec_permission==='on');
          commit('SET_ORDER_SN_PERMISSION', data.order_sn_permission==='on');
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 登出
    LogOut({ commit, state }){
      return new Promise((resolve, reject) => {
        logout(state.userToken).then(() => {
          commit('SET_USER_TOKEN', '');
          removeUserToken();
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 前端 登出
    FedLogOut({ commit }){
      return new Promise(resolve => {
        commit('SET_USER_TOKEN', '');
        removeUserToken();
        resolve();
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js